'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getFormSelector(type) {
  return '[data-hs-cos-general-type="widget"][data-hs-cos-type="' + type + '"] form';
}

function getInputSelector(name, type) {
  var attrs = [name && '[name="' + name + '"]', type && '[type="' + type + '"]'].filter(Boolean).join('');

  return 'input' + attrs;
}

var SUBMIT_BUTTON = getInputSelector(null, 'Submit');
var EMAIL_INPUT = getInputSelector('email');
var PASSWORD_INPUT = getInputSelector('password');
var PASSWORD_REQUIREMENTS = '#hs-membership-password-requirements';
var PASSWORD_CONFIRM_INPUT = getInputSelector('password_confirm');

var LOGIN = exports.LOGIN = {
  FORM: getFormSelector('member_login'),
  EMAIL_INPUT: EMAIL_INPUT,
  PASSWORD_INPUT: PASSWORD_INPUT,
  REMEMBER_ME: getInputSelector('remember_me'),
  SUBMIT_BUTTON: SUBMIT_BUTTON
};

var REGISTER = exports.REGISTER = {
  FORM: getFormSelector('member_register'),
  EMAIL_INPUT: EMAIL_INPUT,
  PASSWORD_INPUT: PASSWORD_INPUT,
  PASSWORD_REQUIREMENTS: PASSWORD_REQUIREMENTS,
  PASSWORD_CONFIRM_INPUT: PASSWORD_CONFIRM_INPUT,
  SUBMIT_BUTTON: SUBMIT_BUTTON
};

var PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_REQUEST = {
  FORM: getFormSelector('password_reset_request'),
  EMAIL_INPUT: EMAIL_INPUT,
  SUBMIT_BUTTON: SUBMIT_BUTTON
};

var PASSWORD_RESET = exports.PASSWORD_RESET = {
  FORM: getFormSelector('password_reset'),
  VERIFICATION_CODE_INPUT: getInputSelector('verification_code'),
  EMAIL_INPUT: getInputSelector('email', 'hidden'),
  PASSWORD_INPUT: PASSWORD_INPUT,
  PASSWORD_REQUIREMENTS: PASSWORD_REQUIREMENTS,
  PASSWORD_CONFIRM_INPUT: PASSWORD_CONFIRM_INPUT,
  SUBMIT_BUTTON: SUBMIT_BUTTON
};


//////////////////
// WEBPACK FOOTER
// ./js/constants/selectors.js
// module id = 6
// module chunks = 0 1 2 3